import React, { Component } from "react";
import { managementOrderDetail } from "./services";
import Spinner from "../../../base/features/micro/Spinner";
import { FiChevronRight, FiMoreVertical } from "react-icons/fi";
import ConnectionsModal from "../../../base/features/blocks/ConnectionsModal";
import Image from "../../../base/features/micro/Image";
import NeshanMap from "react-neshan-map-leaflet";
import { mapKey } from "../../../settings/config";
import { RiExternalLinkLine } from "react-icons/ri";
import ProductCard from "../../../base/features/blocks/ProductCard";
import OrderDetailFooter from "./blocks/OrderDetailFooter";
import Lightbox from "react-image-lightbox";
import { Nav, Tab } from "react-bootstrap";
import { apiService } from "../../../base/utils/service";
import Swal from "sweetalert2";

class ManagementOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      orderId: window.location.pathname.split("/")[4],
      order: null,
      phoneDetail: false,
      defaultActiveKey: "detail",
    };
  }

  componentDidMount() {
    this.getOrderDetail();
  }
  getOrderDetail() {
    managementOrderDetail(this.state.shopUid, this.state.orderId).then(
      (items) => {
        items && this.setState({ order: items });
      }
    );
  }
  getShiping() {
    apiService(
      `v1/shops/${this.state.shopUid}/orders/${this.state.orderId}/shipping`
    ).then((data) => {
      data &&
        this.setState({
          providers: data.shipping_providers,
          provider: data.shipping_provider,
          trackingCode: data.shipping_tracking_code,
          link: data.shipping_link,
        });
    });
  }
  sendCode() {
    var params = {
      shipping_link: !this.state.link.includes("http")
        ? "https://" + this.state.link
        : this.state.link,
      shipping_tracking_code: this.state.trackingCode,
      shipping_provider: this.state.provider.uid,
      status: 3,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/orders/${this.state.orderId}`,
      "put",
      params
    ).then((data) => {
      data &&
        Swal.fire({
          text: "با موفقیت انجام شد",
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 2000,
          width: 180,
          timerProgressBar: true,
        });
    });
  }
  validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  }
  render() {
    return (
      <div id="my-body">
        {/* <ManagementOrderDetailHeader
          text={this.state.order.user.name}
          path={`/dashboard/${this.state.shopUid}/orders`}
        /> */}
        <Tab.Container
          className="border-0 w-100"
          activeKey={this.state.defaultActiveKey}
          onSelect={(i) => this.setState({ defaultActiveKey: i })}
          defaultActiveKey={this.state.defaultActiveKey}
          id="tab-example4"
        >
          <div
            className="row mx-0 bg-white position-fixed shadow-sm"
            style={{ top: "0", left: "0", right: "0", zIndex: "9999999" }}
          >
            <div className="col-12 px-4 py-2-3">
              <FiChevronRight
                onClick={() => window.history.back()}
                className="ms-2"
                size="30"
              />
              <h1 className="fw-bold fs-4 mb-0 d-inline-block align-bottom">
                مدیریت سفارش
              </h1>
            </div>
            <div className="col-2 px-0" />

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "detail"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="detail"
              >
                جزئیات
              </Nav.Link>
            </div>

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "send"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="send"
                onClick={() => this.getShiping()}
              >
                ارسال
              </Nav.Link>
            </div>
            <div className="col-2 px-0" />
          </div>

          <div className="row mx-0" style={{ marginTop: "45px" }}>
            <div className="col-12 px-0">
              <Tab.Content>
                <Tab.Pane eventKey="detail">
                  {this.state.order ? (
                    <section>
                      <div
                        className="row mx-0 px-0"
                        style={{ marginTop: "70px", marginBottom: "65px" }}
                      >
                        <div className="col-12 fw-bolder fs-4 p-3 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-auto px-1 align-self-center">
                              <Image
                                imageUri={
                                  this.state.order.user.image &&
                                  this.state.order.user.image
                                }
                                imageHeight={"35"}
                                imageWidth={"35"}
                                imgClassName={"rounded-circle img-cover"}
                                extraClassName={"rounded-2 bg-color-main p-1"}
                              />
                            </div>
                            <div className="col px-1 align-self-center">
                              <p className="fw-bold mb-0 fs-5">
                                {this.state.order.user.name}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 px-4 py-3 fs-6 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-auto fw-bold px-0 align-self-center">
                              <p className="mb-0">تعداد کل سفارش</p>
                            </div>
                            <div className="col text-start px-0 fs-5 fw-bolder align-self-center">
                              <p className="mb-0">
                                {this.state.order.total_quantity}
                                <span className="me-1 fs-6">عدد</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 px-4 py-3 fs-6 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-auto fw-bold px-0 align-self-center">
                              <p className="mb-0">قیمت کل</p>
                            </div>
                            <div className="col text-start px-0 fs-5 fw-bolder align-self-center">
                              <p
                                className="mb-0"
                                style={{
                                  color: this.state.order.payable_price.color,
                                }}
                              >
                                {this.state.order.payable_price.title}
                                <span className="me-1 fs-7">
                                  {this.state.order.payable_price.currency}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 px-4 py-3 fs-6 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-auto fw-bold px-0 align-self-center">
                              <p className="mb-0">زمان ثبت سفارش</p>
                            </div>
                            <div className="col text-start px-0 fs-6 fw-bolder align-self-center">
                              <p className="mb-0">{this.state.order.created}</p>
                            </div>
                          </div>
                        </div>
                        {this.state.order.shipping_time && (
                          <div className="col-12 px-4 py-3 fs-6 border-bottom">
                            <div className="row mx-0 px-0">
                              <div className="col-auto fw-bold px-0 align-self-center">
                                <p className="mb-0">زمان تحویل</p>
                              </div>
                              <div className="col text-start px-0 fs-6 fw-bolder align-self-center">
                                <p className="mb-0">
                                  {this.state.order.shipping_time}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-12 px-4 py-3 fs-6 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-auto fw-bold px-0 align-self-center">
                              <p className="mb-0">شماره تماس</p>
                            </div>
                            <div className="col text-start px-0 fs-6 fw-bolder align-self-center">
                              <p
                                className="mb-0 color-second"
                                onClick={() =>
                                  this.setState({ phoneDetail: true })
                                }
                              >
                                {this.state.order.user.phone}
                                <FiMoreVertical size="18" />
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 px-4 py-3 fs-6 border-bottom">
                          <div className="row mx-0 px-0">
                            <div className="col-12 px-0 align-self-center">
                              <p className="fw-bold">شیوه پرداخت</p>
                              <p className="mb-0 small">
                                {/*<img*/}
                                {/*  className="me-1"*/}
                                {/*  src={*/}
                                {/*    require("../../../base/assets/icons/Document.svg")*/}
                                {/*      .default*/}
                                {/*  }*/}
                                {/*  alt="document"*/}
                                {/*/>*/}
                                {this.state.order.payment_type}
                              </p>
                            </div>
                            <div className="col-12 px-0 align-self-center">
                              {this.state.order.payment_des}
                            </div>
                          </div>
                        </div>
                        {this.state.order.receipt && (
                          <div className="col-12 px-4 py-3 fs-6 border-bottom">
                            <div className="row mx-0 px-0">
                              <div className="col-12 px-0 align-self-center">
                                <p className="fw-bold">فیش واریز</p>
                              </div>
                              <div className="col-12 px-0">
                                <section
                                  onClick={() =>
                                    this.setState({
                                      selectedImage: this.state.order.receipt,
                                      lightbox: true,
                                    })
                                  }
                                >
                                  <Image
                                    imageUri={
                                      this.state.order.receipt &&
                                      this.state.order.receipt
                                    }
                                    imageHeight={"100"}
                                    imageWidth={"100"}
                                    imgClassName={"img-cover"}
                                    extraClassName={
                                      "rounded-2 bg-color-main p-3"
                                    }
                                  />
                                </section>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.order.receipt &&
                          this.state.lightbox &&
                          this.state.selectedImage && (
                            <Lightbox
                              mainSrc={this.state.selectedImage}
                              reactModalStyle={{
                                overlay: {
                                  zIndex: "100000000",
                                },
                                content: {
                                  zIndex: "100000000",
                                },
                              }}
                              onCloseRequest={() =>
                                this.setState({ lightbox: false })
                              }
                            />
                          )}
                        {this.state.order.des && (
                          <div className="col-12 px-4 py-3 fs-6 border-bottom">
                            <p className="fs-5 fw-bold">توضیحات</p>
                            <p
                              className=""
                              style={{ whiteSpace: "break-spaces" }}
                            >
                              {this.state.order.des}
                            </p>
                          </div>
                        )}
                        {this.state.order.address.address && (
                          <div className="col-12 px-4 py-3 fs-6 border-bottom">
                            <div className="row mx-0 px-0">
                              <div className="col-12 px-0 align-self-center">
                                <p className="fs-5 fw-bold">آدرس</p>
                                <p className="fw-bold">
                                  {this.state.order.address.address}
                                </p>
                              </div>

                              {this.state.order.address.phone && (
                                <div className="col-12 px-0 mb-4">
                                  <img
                                    src={
                                      require("../../addresses/icons/phone.svg")
                                        .default
                                    }
                                    alt="phone"
                                    width="22"
                                  />
                                  <span className="me-2">
                                    {this.state.order.address.phone}
                                  </span>
                                </div>
                              )}
                              {this.state.order.address.postcode && (
                                <div className="col-12 px-0">
                                  <img
                                    src={
                                      require("../../addresses/icons/note.svg")
                                        .default
                                    }
                                    alt="note"
                                    width="22"
                                  />
                                  <span className="me-2">
                                    {this.state.order.address.postcode}
                                  </span>
                                </div>
                              )}
                              {this.state.order.address.latitude &&
                                this.state.order.address.longitude && (
                                  <div
                                    className="col-12 px-0 position-relative mt-3"
                                    id="map"
                                  >
                                    <a
                                      rel="noreferrer"
                                      target="_blank"
                                      href={`https://maps.google.com/?q=${this.state.order.address.latitude},${this.state.order.address.longitude}`}
                                    >
                                      <NeshanMap
                                        style={{
                                          height: "170px",
                                          top: "0",
                                          left: "0",
                                          width: "100%",
                                          borderRadius: "14px",
                                        }}
                                        options={{
                                          key: mapKey,
                                          center: [
                                            this.state.order.address.latitude,
                                            this.state.order.address.longitude,
                                          ],
                                          zoom: 13,
                                          maptype: "dreamy-gold",
                                          poi: true,
                                        }}
                                        onInit={(L, myMap) => {
                                          L.marker([
                                            this.state.order.address.latitude,
                                            this.state.order.address.longitude,
                                          ]).addTo(myMap);
                                        }}
                                      />
                                    </a>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                        <div className="col-12 px-4 fw-bolder fs-5 mt-3">
                          <p>سفارشات</p>
                        </div>
                        <div className="col-12 px-0">
                          {this.state.order.items.map((product, p) => (
                            <div key={p} className="col-12 p-0 border-bottom">
                              <ProductCard
                                image={product.image}
                                product={product}
                                productId={product.product_id}
                                payable_price={product.payable_price}
                                quantity={product.quantity}
                                isOrder={true}
                                shopUid={this.state.order.uid}
                              />
                            </div>
                          ))}
                        </div>

                        {this.state.phoneDetail && (
                          <ConnectionsModal
                            phone={this.state.order.user.phone}
                            connectionsModalChange={(value) =>
                              this.setState({ phoneDetail: value })
                            }
                            connectionsModal={this.state.phoneDetail}
                          />
                        )}
                      </div>
                      <OrderDetailFooter
                        status_obj={this.state.order.status_obj}
                        status={this.state.order.status}
                        setOrderChange={(order) =>
                          this.setState({ order: order })
                        }
                      />
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="send" style={{ marginTop: "90px" }}>
                  {this.state.providers ? (
                    <section>
                      {this.state.provider &&
                        (this.state.provider.shipping_config.has_share_link ||
                          this.state.provider.shipping_config
                            .has_tracking_code) && (
                          <div className="row mx-0 px-4 mb-4">
                            <div className="row mx-0 rounded14 bg-light-gray p-3">
                              {this.state.provider.shipping_config
                                .has_share_link && (
                                <div className="row mx-0 px-0">
                                  <button
                                    disabled={!this.state.link}
                                    className="col-auto btn px-1 align-self-center"
                                  >
                                    <a
                                      href={this.state.link}
                                      rel="noreferrer"
                                      target="_blank"
                                    >
                                      <div className="bg-color-main p-1 rounded7 text-white">
                                        <RiExternalLinkLine size={22} />
                                      </div>
                                    </a>
                                  </button>
                                  <div className="col px-1 position-relative">
                                    <input
                                      className="form-control border-2 bg-light-gray rounded14 p-3 fw-bold"
                                      placeholder="لینک سفر"
                                      value={this.state.link}
                                      dir={this.state.link ? "ltr" : "rtl"}
                                      onChange={(e) =>
                                        this.setState({ link: e.target.value })
                                      }
                                    />
                                    {this.state.link && (
                                      <span
                                        className="position-absolute fs-7 color-main bg-light-gray px-2"
                                        style={{ top: "-8px", right: "20px" }}
                                      >
                                        لینک سفر
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                              {this.state.provider.shipping_config
                                .has_tracking_code && (
                                <div className="row mx-0 px-0 mt-3">
                                  <div className="col-auto px-1 align-self-center">
                                    <a
                                      href={
                                        this.state.provider.shipping_config
                                          .tracking_link
                                      }
                                      rel="noreferrer"
                                      target="_blank"
                                    >
                                      <div className="bg-color-main p-1 rounded7 text-white">
                                        <RiExternalLinkLine size={22} />
                                      </div>
                                    </a>
                                  </div>
                                  <div className="col px-1 position-relative">
                                    <input
                                      className="form-control bg-light-gray border-2 rounded14 p-3 fw-bold"
                                      placeholder="کد رهگیری"
                                      value={this.state.trackingCode}
                                      dir={
                                        this.state.trackingCode ? "ltr" : "rtl"
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          trackingCode: e.target.value,
                                        })
                                      }
                                    />
                                    {this.state.trackingCode && (
                                      <span
                                        className="position-absolute fs-7 color-main bg-light-gray px-2"
                                        style={{ top: "-8px", right: "20px" }}
                                      >
                                        کد رهگیری
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                              <div className="col-12 px-0 mt-3">
                                <button
                                  disabled={
                                    !this.state.link ||
                                    !this.validURL(this.state.link) ||
                                    (this.state.provider.shipping_config
                                      .has_tracking_code &&
                                      !this.state.trackingCode)
                                  }
                                  onClick={() => this.sendCode()}
                                  className="btn py-2-3 bg-disabled fw-bold bg-color-main rounded28 text-white w-100"
                                >
                                  ثبت
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      <div className="row mx-0 px-4">
                        {this.state.providers.map((provider, p) => (
                          <div className="col-6 p-2 text-center position-relative">
                            <div
                              className={`rounded14 shadow-sm p-2 ${
                                this.state.provider &&
                                this.state.provider.uid === provider.uid &&
                                "border-color-main"
                              }`}
                              onClick={() =>
                                this.setState({ provider: provider, link: "" })
                              }
                            >
                              <Image
                                imageHeight={"50"}
                                imageWidth={"50"}
                                extraClassName={
                                  "p-2 img-contain bg-color-main rounded14"
                                }
                                imgClassName={"rounded-circle img-cover"}
                                imageUri={provider.cover && provider.cover.file}
                              />
                              <span className="me-2 fw-bold">
                                {provider.title}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

export default ManagementOrderDetail;
